import React, { useState } from 'react';
import styles from './ViewSourceRecord/ViewSourceRecord.module.scss';
import DeleteContractModal from './DeleteContract/DeleteContractModal';
import HistoryLog from './HistoryLog/HistoryLog';
import ViewSourceRecord from './ViewSourceRecord/ViewSourceRecord';
import ContractSummary from './ContactSummary/ContractSummary';
import AuthorisedUsersWorkflowModal from '../ContractManager/AuthorisedUsersWorkflowModal';



const ECATSRecordPopup = ({ onViewSource, onDelete, onViewHistory, onSummary }) => {
    const [showSourcePopup, setShowSourcePopup] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showHistoryLog, setShowHistoryLog] = useState(false);
    const [showContractSummary, setShowContractSummary] = useState(false);

    const handleViewSource = () => {
        setShowSourcePopup(true);
        if (onViewSource) onViewSource();
    };

    const handleDelete = () => {
        setShowDeletePopup(true);
        if (onDelete) onDelete();
    };

    const handleViewHistory = () => {
        setShowHistoryLog(true);
        if (onViewHistory) onViewHistory();
    };

    const handleContractSummary = () => {
        setShowContractSummary(true);
        if (onSummary) onSummary();
    };


    return (
        <>
            <div className={styles.sidebarMenu}>
                <div className={styles.menuTitle}>Enter Contract Data</div>
                <div className={styles.menuInactive}>Activate</div>
                <button className={styles.menuButton} onClick={handleViewSource}>View Source Record</button>
                <button className={styles.menuButton} onClick={handleDelete}>Delete</button>
                <button className={styles.menuButton} onClick={handleViewHistory}>View History Log</button>
                <button className={styles.menuButton} onClick={handleContractSummary}>Contract Summary</button>
            </div>

            <ViewSourceRecord
                isOpen={showSourcePopup}
                onClose={() => setShowSourcePopup(false)}
            />
            <DeleteContractModal
                isOpen={showDeletePopup}
                onClose={() => setShowDeletePopup(false)}
            />
            <HistoryLog
                isOpen={showHistoryLog}
                onClose={() => setShowHistoryLog(false)}
            />
            <ContractSummary
                isOpen={showContractSummary}
                onClose={() => setShowContractSummary(false)}
            />
           
        </>
    );
};

export default ECATSRecordPopup;